<template lang="pug">
  b-modal#addRTFComm(
  ref="addRTFComm"
  :title="$t('ui.combine.add_rtf')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_rtfId"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_rtfId.$dirty"
          :error="$v.dataAdd_rtfId.$error"
          v-model.trim.lazy="$v.dataAdd_rtfId.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_rtfId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_rtfId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_rtfName.$dirty"
          :error="$v.dataAdd_rtfName.$error"
          v-model.trim.lazy="$v.dataAdd_rtfName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_rtfName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_rtfName" :name="$t('ui.description')")
      b-form-group(:label="$t('ui.description')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_rtfDescription.$dirty"
          :error="$v.dataAdd_rtfDescription.$error"
          v-model.trim.lazy="$v.dataAdd_rtfDescription.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_rtfDescription.$params.maxLength.max"
        )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, numeric } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_rtfId: "",
      dataAdd_rtfName: "",
      dataAdd_rtfDescription: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_rtfId: {
      required,
      numeric,
      minLength: minLength(1),
      maxLength: maxLength(30)
    },
    dataAdd_rtfName: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(100)
    },
    dataAdd_rtfDescription: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(500)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editRtfCommUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.rtfcommentary,
          RTFCommentaryID: this.dataAdd_rtfId,
          RTFCommentaryName: this.dataAdd_rtfName,
          RTFCommentaryDescription: this.dataAdd_rtfDescription
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_rtfId, this.dataAdd_rtfName, this.dataAdd_rtfDescription);
                  this.$refs.addRTFComm.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_rtf", this.feedback.status);
                  this.$refs.addRTFComm.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_rtfId = "";
      this.dataAdd_rtfName = "";
      this.dataAdd_rtfDescription = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_rtfId.$el.focus();
    }
  }
};
</script>
